import React from "react";
import Select from "react-select";
import { ImSpinner2 } from "react-icons/im";
import { BiSolidCity } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import empty from "../../../../../../assets/images/empty.png";

const PriorityPassCategories = ({
  selectedCity,
  setSelectedCity,
  citiesDataForSelect,
  isLoading,
  currentCity, // Receive currentCity
  passes, // Receive global passes (if not tied to currentCity.passes)
  setIsPassDetailModalOpen,
  setCurrentPass,
  handleDeletePass,
}) => {
  // Determine which passes to display.
  // If `currentCity.passes` exists and has data, use that.
  // Otherwise, fallback to the global `passes` if they are not city-specific.
  // The structure `currentCity?.passes` implies your backend sends passes within the city object.
  const passesToDisplay = currentCity?.passes || passes;

  return (
    <div>
      <div className="mt-5">
        {/* City Select */}
        <div className="lg:w-[30%] w-full flex flex-col gap-y-1">
          <label htmlFor="service" className="text-sm">
            Select City
          </label>
          <div className="flex h-11 items-center border-[0.3px] bg-transparent focus:outline-none border-gray-400 py-2 px-2 gap-x-2 w-full rounded-lg">
            <div className="w-[5%]">
              <BiSolidCity size={16} className="text-gray-500" />
            </div>

            <div className="w-[95%] text-shuttlelaneBlack text-sm relative z-[90]">
              <Select
                value={selectedCity}
                onChange={(value) => {
                  setSelectedCity(value);
                }}
                options={citiesDataForSelect}
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    borderColor: state.isFocused
                      ? "transparent"
                      : "transparent",
                    borderWidth: state.isFocused ? "0" : "0",
                    backgroundColor: "transparent",
                    position: "relative",
                  }),
                  placeholder: (baseStyles) => ({
                    ...baseStyles,
                    fontSize: ".875rem",
                  }),
                  menuList: (baseStyles) => ({
                    ...baseStyles,
                    fontSize: ".875rem",
                  }),
                  input: (baseStyles) => ({
                    ...baseStyles,
                    fontSize: ".875rem",
                  }),
                }}
                placeholder="Select City"
              />
            </div>
          </div>
        </div>
      </div>

      {isLoading && (
        <div className="flex flex-col gap-y-5 mt-5 w-full items-center">
          <ImSpinner2
            size={20}
            className="text-shuttlelanePurple animate-spin"
          />
        </div>
      )}

      {/* PASSES TABLE */}
      {!isLoading && (
        <div className="mt-5 w-full lg:overflow-x-hidden overflow-x-scroll shuttlelaneScrollbarHoriz shuttlelaneScrollbar">
          {/* Table header */}
          <div className="maxContent lg:max-w-full lg:min-w-full flex justify-between items-baseline mb-2 border-b-[.3px] border-b-gray-100 text-gray-400 mt-2">
            <p className="w-[200px] lg:w-[33.3%] text-xs">Pass Type</p>
            <p className="w-[200px] lg:w-[33.3%] text-xs">Price</p>
            <p className="w-[200px] lg:w-[33.3%] text-xs">Actions</p>{" "}
            {/* Added Actions column */}
          </div>

          {/* Table body */}
          {passesToDisplay?.length > 0 ? (
            passesToDisplay.map((pass) => (
              <div
                key={pass?._id} // Ensure a unique key
                onClick={() => {
                  setIsPassDetailModalOpen(true);
                  setCurrentPass(pass);
                }}
                className="flex maxContent cursor-pointer lg:max-w-full lg:min-w-full justify-between items-baseline mb-2 pb-2 border-b-[.3px] border-b-gray-100 text-shuttlelaneBlack mt-4"
              >
                <p
                  className={`w-[200px] lg:w-[33.3%] text-xs ${
                    isLoading && "text-gray-400"
                  }`}
                >
                  {pass?.name}
                </p>
                <p
                  className={`w-[200px] lg:w-[33.3%] text-xs ${
                    isLoading && "text-gray-400"
                  }`}
                >
                  ₦{Intl.NumberFormat("en-US", {}).format(pass?.price)}
                </p>
                <p
                  className={`w-[200px] lg:w-[33.3%] text-xs ${
                    isLoading && "text-gray-400"
                  }`}
                >
                  {/* Delete button for each pass */}
                  <AiFillDelete
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent modal from opening when clicking delete
                      setCurrentPass(pass); // Set current pass for handleDeletePass to work
                      handleDeletePass(pass?._id); // Call the delete handler
                    }}
                    size={16}
                    className="text-red-500 cursor-pointer"
                  />
                </p>
              </div>
            ))
          ) : (
            <div className="flex flex-col items-center gap-y-5 text-center mt-10">
              <img
                src={empty}
                className="max-w-[150px] w-[150px] object-contain"
                alt="No passes to show for now"
              />
              <p className="text-center text-sm">
                No passes to show for now...
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PriorityPassCategories;
